/* eslint-disable default-case */

import "bootstrap/dist/css/bootstrap.min.css";
import "semantic-ui-css/semantic.min.css";
import HttpsRedirect from "react-https-redirect";
import * as serviceWorker from "./serviceWorker";

import App from "./App.jsx";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import store from "./redux/store";
import { DndContext } from "@dnd-kit/core";


ReactDOM.render(
  <Provider store={store}>
    <HttpsRedirect>
      <DndContext>
        <App />
      </DndContext>
    </HttpsRedirect>
  </Provider>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
